import { Auth0ProviderOptions } from "@codat/client-cookie-manager";

import config from "config";

export const CLIENT_ID_COOKIE_KEY = `app-${config.ENVIRONMENT.toLowerCase()}-clientid`;

export const auth0Config: Auth0ProviderOptions = {
  domain: config.AUTH0_DOMAIN,
  clientId: config.AUTH0_CLIENTID,
  authorizationParams: {
    audience: "codat-services",
    redirect_uri: window.location.origin,
    scope: "access:codatservice",
  },
};
